import React from 'react'
import { Link } from 'react-router-dom'

import { Button } from '../../components/button'
import { AddAccountPaths } from '../../config/routes'
import { MasaAccount } from '../../models'
import { BankAccountItemSkeleton } from '..'

interface AddProviderAccountProps {
    /** This is provider's name */
    providerName: string
    /** Providers button to link an account */
    providerButton: React.ReactNode
    /** Remder accounts */
    renderAccounts: (account: any, idx: number) => React.ReactNode
    /** Accounts list */
    accounts: MasaAccount[]
    /** Loading indicataor */
    loading?: boolean
    loadingAccounts?: boolean
}

export function AddAccount({
    providerName = 'Provider',
    providerButton,
    renderAccounts,
    accounts = [],
    loading = false,
    loadingAccounts = false,
}: AddProviderAccountProps) {
    return (
        <>
            <h1>Link an account</h1>
            <p className={'mb-4 leading-loose text-black'}>
                We use {providerName} to securely link your account balances and
                transactions to build your financial profile
            </p>

            {!loading ? (
                <>
                    {accounts.length ? <h3>Linked accounts</h3> : <></>}
                    <div
                        className={
                            'overflow-y-scroll space-y-2 mb-8 max-h-96 lg:w-1/2'
                        }>
                        {accounts.map(renderAccounts)}
                    </div>
                </>
            ) : (
                <div className='flex flex-row justify-center mb-8 lg:w-1/3'>
                    <BankAccountItemSkeleton />
                </div>
            )}
            <div className={'flex flex-col'}>
                {providerButton}

                {accounts.length || loadingAccounts ? (
                    <Link to={AddAccountPaths.ADD_CRYPTO_ACCOUNT}>
                        <Button className={'h-16 w-64 mt-8'}> Continue </Button>
                    </Link>
                ) : (
                    <></>
                )}
            </div>
        </>
    )
}
